import * as TYPES from '../types/recentSearchTypes';

const INITIAL_STATE = {
  recentSearch: {},
  loading: false,
  error: false,
  errorMsg: '',
};

export default function recentSearchReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case TYPES.GET_RECENT_SEARCH_ERROR:
      return { ...state, loading: false, error: true, errorMsg: '' };
    case TYPES.GET_RECENT_SEARCH_FAILURE:
      return { ...state, loading: false, error: true, errorMsg: '' };
    case TYPES.GET_RECENT_SEARCH_START:
      return {
        ...state,
        loading: true,
        recentSearch: INITIAL_STATE.recentSearch,
      };
    case TYPES.GET_RECENT_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        recentSearch: action.payload.recentSearch,
      };
    default:
      return state;
  }
}
